import { motion, useScroll, useSpring } from "framer-motion";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Manifesto } from "@/components/site/Manifesto";
import { Coverage } from "@/components/site/Coverage";
import { Social } from "@/components/site/Social";
import { Footer } from "@/components/site/Footer";

export default function ComingSoon() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 24 });

  return (
    <div id="top" data-testid="coming-soon-page" className="relative min-h-screen bg-ink font-jakarta text-slate-100">
      <motion.div
        data-testid="scroll-progress-bar"
        className="fixed inset-x-0 top-0 z-[60] h-0.5 origin-left bg-gradient-to-r from-cyan-400 via-sky-400 to-blue-600"
        style={{ scaleX }}
      />
      <div className="noise-overlay" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Coverage />
        <Social />
      </main>
      <Footer />
    </div>
  );
}
